(() => {
  const nav = document.getElementById('mobile-nav');
  const backdrop = document.querySelector('[data-mobile-nav-backdrop]');
  const triggers = document.querySelectorAll('[data-mobile-nav-trigger]');

  if (!nav) return;

  // Merkt sich das Element, das den Drawer geöffnet hat, um den Fokus beim
  // Schließen dorthin zurückzugeben (WCAG 2.4.3 Focus Order).
  let lastFocused = null;

  // Alle aktuell fokussierbaren Elemente im Drawer (für Focus-Trap + Erstfokus).
  function focusable() {
    return Array.prototype.filter.call(
      nav.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ),
      el => el.offsetParent !== null // sichtbar
    );
  }

  function open() {
    lastFocused = document.activeElement;
    nav.dataset.open = 'true';
    nav.setAttribute('aria-hidden', 'false');
    backdrop.classList.remove('opacity-0', 'pointer-events-none');
    backdrop.classList.add('opacity-100');
    document.body.style.overflow = 'hidden';
    triggers.forEach(t => t.setAttribute('aria-expanded', 'true'));
    // Fokus in den Drawer setzen (erstes fokussierbares Element).
    const f = focusable();
    if (f.length) f[0].focus();
  }

  function close() {
    nav.dataset.open = 'false';
    nav.setAttribute('aria-hidden', 'true');
    backdrop.classList.add('opacity-0', 'pointer-events-none');
    backdrop.classList.remove('opacity-100');
    document.body.style.overflow = '';
    triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
    // Fokus zurück zum Auslöser (z.B. Burger-Button).
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      nav.dataset.open === 'true' ? close() : open();
    });
  });

  backdrop.addEventListener('click', close);

  nav.addEventListener('click', e => {
    const link = e.target.closest('a[href]');
    if (link && nav.contains(link)) close();
  });

  document.addEventListener('keydown', e => {
    if (nav.dataset.open !== 'true') return;

    if (e.key === 'Escape') {
      close();
      return;
    }

    // Focus-Trap: Tab/Shift+Tab zyklisch im Drawer halten, statt dahinter zu
    // entkommen (WCAG 2.4.3 / 2.1.2 No Keyboard Trap — Escape bietet den Ausweg).
    if (e.key === 'Tab') {
      const f = focusable();
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!nav.contains(document.activeElement)) {
        // Fokus ist irgendwie aus dem Drawer entwichen → zurückholen.
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
